import { render } from "./trust.vue?vue&type=template&id=5d8e8faf"
import script from "./trust.js?vue&type=script&lang=js&external"
export * from "./trust.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__